























































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component({})
export default class ProjectReportCardComponent extends Vue {
  @Prop({ required: true }) stationName!: string;
  @Prop({ required: true }) customerName!: string;
  @Prop({ default: '' }) description!: string;
  @Prop({ required: true }) activeMaintenanceCount!: number;
  @Prop({ required: true }) openMaintenanceCount!: number;
  @Prop({ default: 0 }) overdueMaintenanceCount!: number;
  @Prop({ default: null }) nextMaintenance!: string | null;
  @Prop({ required: true }) color!: string;
  @Prop({ required: true }) route!: object;

  public get nextMaintenanceDisplay(): string {
    if (!this.nextMaintenance) return '–';
    return moment(String(this.nextMaintenance)).format('DD.MM.YYYY');
  }
}
